export function getTenantLogoUrl(logoValue) {
  if (!logoValue || typeof logoValue !== "string") return null;

  const trimmed = logoValue.trim();
  if (!trimmed) return null;

  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith("data:")) {
    return trimmed;
  }

  const parts = trimmed.split("/").filter(Boolean);
  if (parts.length >= 3) {
    return `https://madar-api.madar.iq/uploads/${parts[1]}/${parts[0]}/${parts[2]}`;
  }

  const tenantId = localStorage.getItem("tenantId") || "0";
  if (!trimmed.includes("/") && tenantId !== "0") {
    return `https://madar-api.madar.iq/uploads/${tenantId}/TenantDtl/${trimmed}`;
  }

  if (trimmed.startsWith("/uploads/")) {
    return `https://madar-api.madar.iq${trimmed}`;
  }

  return `https://madar-api.madar.iq/${trimmed.replace(/^\/+/, "")}`;
}
